export default __webpack_public_path__ + "static/media/binancelogo.64511797.PNG";